import type { Snapshot } from '@/entities/snapshot';
import request from '@/shared/api/request';

/**
 * Returns a specified Snapshot.
 *
 * @param id { number } The ID of the Snapshot.
 */
export const getSnapshot = (id: number): Promise<{ snapshot: Snapshot }> =>
  request({
    url: `/snapshots/${id}`,
    method: 'GET',
  });
